function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2583",
  "data-name": "Group 2583",
  transform: "translate(-572.21 -24.313)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3719",
  "data-name": "Path 3719",
  d: "M574.33,71.8s10.128,10.8,20.93,0a14.955,14.955,0,0,1,20.93,0c5.807,5.807,14.544,6.386,20.93,0",
  transform: "translate(0 -26.905)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3720",
  "data-name": "Path 3720",
  d: "M574.33,78.423s10.128,10.8,20.93,0a14.956,14.956,0,0,1,20.93,0c5.807,5.807,14.544,6.386,20.93,0",
  transform: "translate(0 -22.192)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3721",
  "data-name": "Path 3721",
  d: "M574.33,85.075s10.128,10.8,20.93,0a14.955,14.955,0,0,1,20.93,0c5.807,5.807,14.544,6.386,20.93,0",
  transform: "translate(0 -17.487)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_570",
  "data-name": "Line 570",
  y1: 3.864,
  x2: 3.648,
  transform: "translate(623.272 77.096)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3722",
  "data-name": "Path 3722",
  d: "M651.443,111.092V101.008l3.864,3.864",
  transform: "translate(-24.522 -23.913)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_571",
  "data-name": "Line 571",
  x1: 3.648,
  y2: 3.864,
  transform: "translate(605.833 32.033)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3723",
  "data-name": "Path 3723",
  d: "M618.721,45.813V55.9l-3.864-3.864",
  transform: "translate(-12.888 -20)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_572",
  "data-name": "Line 572",
  y1: 3.864,
  x2: 3.648,
  transform: "translate(580.451 77.096)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3724",
  "data-name": "Path 3724",
  d: "M588.655,111.092V101.008l3.864,3.864",
  transform: "translate(-4.555 -23.913)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}));

var SvgElasticity2Icon = function SvgElasticity2Icon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67.033,
    height: 64.367,
    viewBox: "0 0 67.033 64.367",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgElasticity2Icon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/elasticity2-icon.855ac1cd.svg";
export { ForwardRef as ReactComponent };